import { render, staticRenderFns } from "./Izin.vue?vue&type=template&id=74ce37aa&scoped=true&"
import script from "./Izin.vue?vue&type=script&lang=js&"
export * from "./Izin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ce37aa",
  null
  
)

export default component.exports